import React from 'react';
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUndo, faFileExcel, faSave, faSort, faSortUp, faSortDown, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx';

class ReporteFacturacion extends React.Component {
    constructor(props) {
        super(props);
        const today = new Date().toISOString().split('T')[0];
        this.state = {
            cargando: false,
            selectedItems: [],
            isSendingNote: false,
            facturas: [],
            ordenFecha: 'asc', // Orden por fecha de servicio ascendente por defecto
            filtros: {
                fecha_inicio: today,
                fecha_fin: today,
                conductor: '',
                estado_siigo: '',
                especificaciones: '',
                descripcion: ''
            }
        };
    }

    componentDidMount() {
        // Initial load optional
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            filtros: {
                ...prevState.filtros,
                [name]: value
            }
        }));
    };

    handleCostoChange = (id, value) => {
        const facturas = this.state.facturas.map(f => {
            if (f.id === id) {
                return { ...f, costo_conductor: value };
            }
            return f;
        });
        this.setState({ facturas });
    };

    guardarCosto = (id, costo_conductor) => {
        if (!costo_conductor || Number(costo_conductor) <= 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Validación',
                text: 'Debe ingresar un valor mayor a 0 para guardar el costo del conductor.'
            });
            return;
        }

        authAxios.post('facturacion/actualizar_costo_conductor', { id, costo_conductor })
            .then(res => {
                if (res.data.status === 200 || res.data === 'ok' || res.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: 'Costo conductor actualizado correctamente',
                        timer: 1500,
                        showConfirmButton: false
                    });
                }
            })
            .catch(err => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo actualizar el costo'
                });
            });
    };

    cargarListado = () => {
        this.setState({ cargando: true });
        Swal.showLoading();

        const { filtros } = this.state;
        authAxios.post("facturacion/reporte_rango", {
            fecha_inicio: filtros.fecha_inicio,
            fecha_fin: filtros.fecha_fin
        })
            .then((res) => {
                Swal.close();
                if (res.data && res.data.dato) {
                    this.setState({
                        facturas: res.data.dato,
                        cargando: false
                    });
                } else {
                    this.setState({ facturas: [], cargando: false });
                }
            })
            .catch((err) => {
                Swal.close();
                console.error("Error cargando listado:", err);
                this.setState({ cargando: false });
                Swal.fire({
                    icon: 'error',
                    title: 'Error de Conexión',
                    text: 'No se pudo consultar el reporte'
                });
            });
    };

    toggleOrdenFecha = () => {
        this.setState(prevState => ({
            ordenFecha: prevState.ordenFecha === 'asc' ? 'desc' : 'asc'
        }));
    };

    limpiarFiltros = () => {
        const today = new Date().toISOString().split('T')[0];
        this.setState({
            filtros: {
                fecha_inicio: today,
                fecha_fin: today,
                conductor: '',
                estado_siigo: '',
                especificaciones: '',
                descripcion: ''
            },
            facturas: []
        });
    };
    
    handleSelectAll = (e, facturasFiltradas) => {
        if (e.target.checked) {
            const ids = facturasFiltradas
                .filter(item => item.enviado_siigo != 1)
                .map(item => item.id);
            this.setState({ selectedItems: ids });
        } else {
            this.setState({ selectedItems: [] });
        }
    };

    handleSelectItem = (id) => {
        this.setState(prevState => {
            const selectedItems = [...prevState.selectedItems];
            const index = selectedItems.indexOf(id);
            if (index > -1) {
                selectedItems.splice(index, 1);
            } else {
                selectedItems.push(id);
            }
            return { selectedItems };
        });
    };

    enviarNotaContable = async () => {
        const { selectedItems, facturas } = this.state;
        
        if (selectedItems.length === 0) {
            Swal.fire('Validación', 'Debe seleccionar al menos un ítem.', 'warning');
            return;
        }

        // Validate items
        const itemsAEnviar = facturas.filter(f => selectedItems.includes(f.id));
        const costosIncompletos = itemsAEnviar.some(item => !item.costo_conductor || Number(item.costo_conductor) <= 0);

        if (costosIncompletos) {
            Swal.fire('Validación', 'Todos los ítems seleccionados deben tener un costo de conductor mayor a 0.', 'warning');
            return;
        }

        const totalEnviar = itemsAEnviar.reduce((sum, item) => sum + (Number(item.costo_conductor) || 0), 0);
        const conductorNombre = itemsAEnviar[0]?.nombre_conductor || itemsAEnviar[0]?.nombre_recauda || '';

        const confirmacion = await Swal.fire({
            title: "¿Enviar Nota Contable?",
            html: `
                <div style="font-size: 14px; text-align: left;">
                    <p style="text-align: center; margin-bottom: 12px;">Se enviará la nota contable a Siigo con los siguientes datos:</p>
                    <div style="background-color: #f8f9fa; border: 1px solid #dee2e6; border-radius: 8px; padding: 12px; margin-bottom: 10px;">
                        <p style="margin: 4px 0;"><strong>Ítems seleccionados:</strong> <span class="badge bg-primary fs-6">${selectedItems.length}</span></p>
                        <p style="margin: 4px 0;"><strong>Valor Total a Enviar:</strong> <span style="color: #28a745; font-size: 18px; font-weight: bold;">$ ${Number(totalEnviar).toLocaleString()}</span></p>
                        ${conductorNombre ? `<p style="margin: 4px 0;"><strong>Conductor:</strong> ${conductorNombre}</p>` : ''}
                    </div>
                    <p style="color: #dc3545; font-size: 12px; text-align: center; margin-top: 8px;">Esta acción generará la liquidación y no se puede deshacer.</p>
                </div>
            `,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sí, enviar nota contable",
            cancelButtonText: "Cancelar"
        });

        if (!confirmacion.isConfirmed) return;

        this.setState({ isSendingNote: true });
        
        Swal.fire({
            title: "Enviando...",
            html: "Por favor espere mientras se procesa la nota contable.",
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
        });

        try {
            const response = await authAxios.post("facturacion/nota_contable_conductor", { ids: selectedItems });
            Swal.close();

            if (response.data.Status || response.data.status) {
                Swal.fire("Éxito!", "Nota contable enviada correctamente.", "success");
                // Reload list to update status
                this.cargarListado();
                this.setState({ selectedItems: [] });
            } else {
                Swal.fire("Error", response.data.msj || "Error al enviar a Siigo", "error");
            }
        } catch (error) {
            Swal.close();
            Swal.fire("Error", "Ocurrió un error en la conexión.", "error");
        } finally {
            this.setState({ isSendingNote: false });
        }
    };

    getFacturasFiltradas = () => {
        const { facturas, filtros, ordenFecha } = this.state;
        const filtradas = facturas.filter(item => {
            if (filtros.conductor) {
                const term = filtros.conductor.toLowerCase();
                const nombre = (item.nombre_conductor || '').toLowerCase();
                const cedula = String(item.datos_conductor || '').toLowerCase();
                if (!nombre.includes(term) && !cedula.includes(term)) return false;
            }
            if (filtros.estado_siigo !== '') {
                const enviado = item.enviado_siigo == 1;
                if (filtros.estado_siigo === '1' && !enviado) return false;
                if (filtros.estado_siigo === '0' && enviado) return false;
            }
            if (filtros.especificaciones) {
                const specTerm = filtros.especificaciones.toLowerCase();
                const spec = (item.especificaciones || '').toLowerCase();
                if (!spec.includes(specTerm)) return false;
            }
            if (filtros.descripcion) {
                const descTerm = filtros.descripcion.toLowerCase();
                const desc = (item.descripcion || '').toLowerCase();
                if (!desc.includes(descTerm)) return false;
            }
            return true;
        });

        // Ordenamiento por fecha de servicio
        if (ordenFecha === 'asc') {
            filtradas.sort((a, b) => (a.fecha_servicio || '').localeCompare(b.fecha_servicio || ''));
        } else if (ordenFecha === 'desc') {
            filtradas.sort((a, b) => (b.fecha_servicio || '').localeCompare(a.fecha_servicio || ''));
        }

        return filtradas;
    };

    exportarExcel = () => {
        const facturasFiltradas = this.getFacturasFiltradas();
        if (facturasFiltradas.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Atención',
                text: 'No hay datos para exportar.'
            });
            return;
        }

        const formattedData = facturasFiltradas.map(item => {
            const conductorTexto = item.datos_conductor ? `${item.datos_conductor} ${item.nombre_conductor}` : item.nombre_conductor;
            return {
                'FACTURA': item.factura,
                'FECHA': item.fecha_factura,
                'COD': item.codigo,
                'CLIENTE': item.cliente,
                'MODALIDAD': item.modalidad,
                'DESCRIPCION': item.descripcion,
                'CANT.': item.cantidad,
                'VALOR': item.valor,
                'TOTAL': item.total,
                'EXPEDIENTE': item.numero_expediente,
                'PLACA': item.placa,
                'CONDUCTOR': conductorTexto,
                'CEDULA RECAUDO': item.cedula_cobra,
                'NOMBRE RECAUDO': item.nombre_recauda,
                'ESPECIFICACIONES': item.especificaciones,
                'COSTO TERCERO': item.costo_tercero,
                'COSTO CONDUCTOR': item.costo_conductor
            };
        });

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte");
        XLSX.writeFile(workbook, "Reporte_Facturacion.xlsx");
    };

    render() {
        const { filtros, cargando, selectedItems, isSendingNote, ordenFecha } = this.state;
        const facturasFiltradas = this.getFacturasFiltradas();
        
        const uniqueDrivers = new Set(facturasFiltradas.filter(f => f.datos_conductor).map(f => String(f.datos_conductor)));
        const esUnSoloConductor = uniqueDrivers.size === 1 && facturasFiltradas.length > 0;
        const selectableCount = facturasFiltradas.filter(f => f.enviado_siigo != 1).length;
        const allSelected = selectableCount > 0 && selectedItems.length === selectableCount;

        // Calcular total y cantidad seleccionada
        const itemsSeleccionados = facturasFiltradas.filter(f => selectedItems.includes(f.id));
        const totalSeleccionado = itemsSeleccionados.reduce((sum, item) => sum + (Number(item.costo_conductor) || 0), 0);

        return (
            <React.Fragment>
                <div className="container-fluid mt-3">
                    <div className="card shadow-sm">
                        <div className="card-header bg-primary text-white">
                            <h5 className="mb-0">Reporte de Facturación</h5>
                        </div>
                        <div className="card-body bg-light">
                            <div className="row g-2 align-items-end mb-2">
                                <div className="col-md-2">
                                    <label className="form-label fw-bold">Fecha Inicio</label>
                                    <input 
                                        type="date" 
                                        className="form-control form-control-sm"
                                        name="fecha_inicio"
                                        value={filtros.fecha_inicio}
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label fw-bold">Fecha Fin</label>
                                    <input 
                                        type="date" 
                                        className="form-control form-control-sm"
                                        name="fecha_fin"
                                        value={filtros.fecha_fin}
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                                <div className="col-md-5">
                                    <label className="form-label fw-bold">Buscar Conductor (Nombre o Cédula)</label>
                                    <input 
                                        type="text" 
                                        className="form-control form-control-sm"
                                        name="conductor"
                                        placeholder="Ingrese nombre o cédula..."
                                        value={filtros.conductor}
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label fw-bold">Estado Siigo</label>
                                    <select 
                                        className="form-select form-select-sm"
                                        name="estado_siigo"
                                        value={filtros.estado_siigo}
                                        onChange={this.handleInputChange}
                                    >
                                        <option value="">Todos</option>
                                        <option value="1">Enviados</option>
                                        <option value="0">No Enviados</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row g-2 align-items-end">
                                <div className="col-md-2">
                                    <label className="form-label fw-bold">Especificaciones</label>
                                    <input 
                                        type="text" 
                                        className="form-control form-control-sm"
                                        name="especificaciones"
                                        placeholder="Buscar..."
                                        value={filtros.especificaciones}
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label fw-bold">Descripción</label>
                                    <input 
                                        type="text" 
                                        className="form-control form-control-sm"
                                        name="descripcion"
                                        placeholder="Buscar descripción..."
                                        value={filtros.descripcion}
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label fw-bold">Orden Fecha Serv.</label>
                                    <select 
                                        className="form-select form-select-sm"
                                        value={ordenFecha}
                                        onChange={(e) => this.setState({ ordenFecha: e.target.value })}
                                    >
                                        <option value="asc">Ascendente (Antiguo a Reciente)</option>
                                        <option value="desc">Descendente (Reciente a Antiguo)</option>
                                    </select>
                                </div>
                                
                                <div className="col-md-5 text-end mt-3">
                                    <button onClick={this.cargarListado} disabled={cargando} className="btn btn-primary btn-sm px-3 shadow-sm me-2">
                                        <FontAwesomeIcon icon={faSearch} className="me-2" />
                                        Buscar
                                    </button>
                                    <button onClick={this.limpiarFiltros} disabled={cargando} className="btn btn-secondary btn-sm px-3 shadow-sm me-2">
                                        <FontAwesomeIcon icon={faUndo} className="me-2" />
                                        Limpiar
                                    </button>
                                    <button onClick={this.exportarExcel} disabled={cargando || facturasFiltradas.length === 0} className="btn btn-success btn-sm px-3 shadow-sm me-2">
                                        <FontAwesomeIcon icon={faFileExcel} className="me-2" />
                                        Exportar
                                    </button>
                                    <button 
                                        onClick={() => window.location.href = `${process.env.PUBLIC_URL}/reportes/liquidaciones/Dubai`} 
                                        className="btn btn-warning btn-sm px-3 shadow-sm me-2 text-dark">
                                        Ver Liquidaciones
                                    </button>
                                    {esUnSoloConductor && (
                                        <button 
                                            onClick={this.enviarNotaContable} 
                                            disabled={cargando || isSendingNote || selectedItems.length === 0} 
                                            className="btn btn-info btn-sm px-3 shadow-sm text-white fw-bold">
                                            <FontAwesomeIcon icon={faPaperPlane} className="me-1" />
                                            {isSendingNote ? 'Enviando...' : (selectedItems.length > 0 ? `Enviar Nota ($ ${Number(totalSeleccionado).toLocaleString()})` : 'Enviar Nota Contable')}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        {esUnSoloConductor && selectedItems.length > 0 && (
                            <div className="alert alert-info py-2 px-3 mb-2 d-flex flex-wrap justify-content-between align-items-center shadow-sm" style={{ fontSize: '13px', borderRadius: '8px' }}>
                                <div>
                                    <span className="me-3">
                                        <strong>Ítems seleccionados:</strong> <span className="badge bg-primary px-2 py-1 ms-1 fs-6">{selectedItems.length}</span>
                                    </span>
                                    <span>
                                        <strong>Total a enviar en Nota Contable:</strong> <span className="fw-bold ms-1 fs-5">$ {Number(totalSeleccionado).toLocaleString()}</span>
                                    </span>
                                </div>
                                <div>
                                    <button 
                                        onClick={this.enviarNotaContable} 
                                        disabled={cargando || isSendingNote} 
                                        className="btn btn-info btn-sm px-3 shadow-sm text-white fw-bold">
                                        <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                                        {isSendingNote ? 'Enviando...' : `Enviar Nota Contable ($ ${Number(totalSeleccionado).toLocaleString()})`}
                                    </button>
                                </div>
                            </div>
                        )}

                        <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                            <table className="table table-bordered table-hover table-sm text-center align-middle" style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>
                                <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                    <tr>
                                        {esUnSoloConductor && (
                                            <th style={{ position: 'sticky', left: 0, zIndex: 3, backgroundColor: '#f8f9fa', width: '50px', minWidth: '50px', maxWidth: '50px' }}>
                                                <input 
                                                    type="checkbox" 
                                                    checked={allSelected} 
                                                    onChange={(e) => this.handleSelectAll(e, facturasFiltradas)}
                                                    disabled={selectableCount === 0}
                                                />
                                            </th>
                                        )}
                                        <th style={{ position: 'sticky', left: esUnSoloConductor ? '50px' : '0px', zIndex: 3, backgroundColor: '#f8f9fa', width: '180px', minWidth: '180px', maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis' }}>Cliente</th>
                                        <th onClick={this.toggleOrdenFecha} style={{ position: 'sticky', left: esUnSoloConductor ? '230px' : '180px', zIndex: 3, backgroundColor: '#f8f9fa', width: '95px', minWidth: '95px', maxWidth: '95px', cursor: 'pointer' }} title="Clic para alternar orden ascendente / descendente">Fecha Serv. <FontAwesomeIcon icon={ordenFecha === 'asc' ? faSortUp : faSortDown} className="ms-1 text-primary" /></th>
                                        <th style={{ position: 'sticky', left: esUnSoloConductor ? '325px' : '275px', zIndex: 3, backgroundColor: '#f8f9fa', width: '115px', minWidth: '115px', maxWidth: '115px', overflow: 'hidden', textOverflow: 'ellipsis', borderRight: '2px solid #dee2e6' }}>Modalidad</th>
                                        <th>Factura</th>
                                        <th>Fecha Fac.</th>
                                        <th>Cod</th>
                                        <th>Descripcion</th>
                                        <th>Cant.</th>
                                        <th>Valor</th>
                                        <th>Total</th>
                                        <th>Costo Tercero</th>
                                        <th>Costo Conductor</th>
                                        <th>Expediente</th>
                                        <th>Placa</th>
                                        <th>Cédula Cond.</th>
                                        <th>Nombre Conductor</th>
                                        <th>Cédula Recaudo</th>
                                        <th>Nombre Recaudo</th>
                                        <th>Especificaciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {facturasFiltradas.length > 0 ? (
                                        facturasFiltradas.map((item, index) => (
                                            <tr key={index}>
                                                {esUnSoloConductor && (
                                                    <td style={{ position: 'sticky', left: 0, zIndex: 1, backgroundColor: '#fff', borderRight: '1px solid #dee2e6', width: '50px', minWidth: '50px', maxWidth: '50px' }}>
                                                        {item.enviado_siigo == 1 ? (
                                                            <span className="badge bg-success">Env</span>
                                                        ) : (
                                                            <input 
                                                                type="checkbox" 
                                                                checked={selectedItems.includes(item.id)}
                                                                onChange={() => this.handleSelectItem(item.id)}
                                                            />
                                                        )}
                                                    </td>
                                                )}
                                                <td className="text-start" style={{ position: 'sticky', left: esUnSoloConductor ? '50px' : '0px', zIndex: 1, backgroundColor: '#fff', width: '180px', minWidth: '180px', maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.cliente}</td>
                                                <td style={{ position: 'sticky', left: esUnSoloConductor ? '230px' : '180px', zIndex: 1, backgroundColor: '#fff', width: '95px', minWidth: '95px', maxWidth: '95px', textAlign: 'center' }}>{item.fecha_servicio}</td>
                                                <td style={{ position: 'sticky', left: esUnSoloConductor ? '325px' : '275px', zIndex: 1, backgroundColor: '#fff', width: '115px', minWidth: '115px', maxWidth: '115px', overflow: 'hidden', textOverflow: 'ellipsis', borderRight: '2px solid #dee2e6' }}>{item.modalidad}</td>
                                                <td>{item.factura}</td>
                                                <td>{item.fecha_factura}</td>
                                                <td>{item.codigo}</td>
                                                <td className="text-start" style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.descripcion}</td>
                                                <td>{item.cantidad}</td>
                                                <td>{Number(item.valor).toLocaleString()}</td>
                                                <td>{Number(item.total).toLocaleString()}</td>
                                                <td>{Number(item.costo_tercero).toLocaleString()}</td>
                                                <td style={{ minWidth: '100px' }}>
                                                    <input 
                                                        type="number" 
                                                        className="form-control text-center form-control-sm"
                                                        value={item.costo_conductor || ''}
                                                        onChange={(e) => this.handleCostoChange(item.id, e.target.value)}
                                                        onBlur={(e) => this.guardarCosto(item.id, e.target.value)}
                                                        title="Se guarda automáticamente al salir del campo"
                                                    />
                                                </td>
                                                <td>{item.numero_expediente}</td>
                                                <td>{item.placa}</td>
                                                <td>{item.datos_conductor}</td>
                                                <td className="text-start">{item.nombre_conductor}</td>
                                                <td>{item.cedula_cobra}</td>
                                                <td>{item.nombre_recauda}</td>
                                                <td>{item.especificaciones}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={esUnSoloConductor ? "18" : "17"} className="text-center text-muted py-4">
                                                No hay resultados para mostrar. Ajuste los filtros y busque de nuevo.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ReporteFacturacion;
